module.exports = __webpack_public_path__ + "img/Jump Casting27.83a59951.jpg";